<template lang="pug">
    v-card(v-if="loading")
        v-skeleton-loader(v-if="loading" type="table")
    v-card(v-else)
        v-card-subtitle Изменения баланса
        v-card-text
            v-data-table.elevation-0.mt-1(
                :headers='tableHeaders'
                fixed-header
                item-key="id"
                disable-pagination
                hide-default-footer
                :items='balanceChanges'
            )
                template(v-slot:item.amount="{ item }") {{ item.amount | toUSD }}
                template(v-slot:item.date="{ item }") {{ item.date | formatDateToLocale }}
                template(v-slot:item.action="{ item }") {{ item.action === 'ADD' ?  'Ввод' : 'Вывод' }}

</template>

<script>
  import ClientApi from '@/api/client';

  export default {
    name: 'ClientBalanceChanges',
    computed: {},
    data() {
      return {
        loading: true,
        balanceChanges: [],
        tableHeaders: [
          {
            text: 'Тип операции',
            align: 'start',
            sortable: true,
            value: 'action',
            fixed: true,
            width: '1%',
            filter: value => {
              if (value === 'ADD') {
                return 'Ввод'
              } else if (value === 'REMOVE') {
                return 'Вывод'
              }
            },
          },
          {
            text: 'Сумма',
            align: 'start',
            sortable: true,
            value: 'amount',
            fixed: true,
            width: '1%',
            // filter: value => {
            //   const sum = this.$options.filters.toUSD(value)
            //   return sum
            // },
          },
          {
            text: 'Дата',
            align: 'start',
            sortable: true,
            value: 'date',
            fixed: true,
            width: '1%',
            // filter: value => {
            //   return this.$options.filters.toUSD(value)
            // },
          },
        ],
      };
    },
    async created() {
      await this.getClientBalanceChanges();
      this.loading = false;
    },
    methods: {
      async getClientBalanceChanges() {
        this.balanceChanges = await ClientApi.getClientBalanceChanges(this.$store.state.auth.user.id);
      },
    },
  };
</script>

<style scoped>

</style>